import { mapGetters } from "vuex";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

const convertNumberService = new ConvertNumService();

export default {
    components: {
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            answers: {
                data: []
            },
            pg_status: false,
            key: '',
            status: 'default',
            CONFIG,
            currentPage: '',
            lastPage: '',
            answerSection: '',
            isDelete: false,
            totalAns: '',
            currentEngPage: ''
        };
    },

    computed: {
        ...mapGetters(["userType", "studentId", "teacherId", "schoolId"]),
    },

    methods: {
        getAnswers(page = 1) {
            axios.get(`my/assignment/${this.$route.params.id}/answer/list?page=` + page)
                .then((response) => {
                    this.answers = response.data;
                    this.answers.data.forEach(answer => {
                        if (answer.description && answer.description.length > 30) {
                            answer.description = answer.description.substring(0, 30) + '...';
                        }
                        if (answer.remark && answer.remark.length > 100) {
                            answer.remark = answer.remark.substring(0, 100) + '...';
                        }
                    });
                    this.totalAns = response.data.total;
                    this.currentEngPage = response.data.current_page;
                    this.answers.total = convertNumberService.convertEng2Mm(this.answers.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.answers.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.answers.current_page);
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Create Answer API Error", error);
                });
        },

        searchAnswers(page = 1) {
            this.pg_status = true;
            axios.get(`my/assignment/${this.$route.params.id}/answer/list/search?page=` + page, {
                params: {
                    key: this.key,
                    status: this.status === 'default' ? '' : this.status
                }
            })
                .then((response) => {
                    this.answers = response.data;
                    this.answers.data.forEach(answer => {
                        if (answer.description.length > 30) {
                            answer.description = answer.description.substring(0, 30) + '...';
                        }
                        if (answer.remark.length > 100) {
                            answer.remark = answer.remark.substring(0, 100) + '...';
                        }
                    });
                    this.totalAns = response.data.total;
                    this.currentEngPage = response.data.current_page;
                    this.answers.total = convertNumberService.convertEng2Mm(this.answers.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.answers.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.answers.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Create Answer API Error", error);
                });
        },

        answerDetail(answerId) {
            this.$emit('changeSection', 'DetailAssignmentAnswer', answerId);
        },

        answerEdit(answerId) {
            this.$emit('changeSection', 'EditAssignmentAnswer', answerId);
        },

        answerCreate() {
            this.$emit('changeSection', 'CreateAssignmentAnswer');
        },

        getNewPageIdx() {
            let newPage = this.currentEngPage;
            const remainItem = this.totalAns - 1;
            const itemPerPage = 10;
            const maxPage = Math.ceil(remainItem / itemPerPage);
            if (newPage > maxPage) {
                newPage = maxPage > 0 ? maxPage : 1;
            }
            return newPage;
        },

        rejectAnswer(answerId) {
            this.axios.delete(`my/assignment/answer/reject/` + answerId)
            .then((response) => {
                if (response.status === 200) {
                    this.$notification.success("assignment ပယ်ဖျက်ခြင်းအောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    let newPage = this.getNewPageIdx();
                    this.getAnswers(newPage);
                } else {
                    this.$notification.success("assignment ပယ်ဖျက်ခြင်းမအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                }
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('/');
                }
                console.log("Create Answer API Error", error);
            });
        },

        approveAnswer(answerId) {
            this.axios.post(`my/assignment/answer/approve/` + answerId)
            .then((response) => {
                if (response.status === 200) {
                    this.getAnswers(this.currentPage);
                    this.$notification.success("assignment လက်ခံခြင်းအောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else {
                    this.$notification.success("assignment လက်ခံခြင်းမအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                }
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('/');
                }
                console.log("Create Answer API Error", error);
            });
        },

        answerDelete(answerId) {
            if (this.isDelete) return;
            this.isDelete = true;
            this.axios.delete(`my/assignment/answer/delete/` + answerId)
                .then((response) => {
                    if (response.status === 200) {
                        this.$notification.success("assignment ဖျက်ခြင်းအောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        let newPage = this.getNewPageIdx();
                        this.getAnswers(newPage);
                    } else {
                        this.$notification.success("assignment ဖျက်ခြင်းမအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Delete Answer API Error", error);
                })
                .finally(() => {
                    this.isDelete = false;
                });
        }
    },

    mounted() {
        this.getAnswers();
    },
};
